import { render, staticRenderFns } from "./MeasurementContent.vue?vue&type=template&id=2f68a711&"
import script from "./MeasurementContent.vue?vue&type=script&lang=js&"
export * from "./MeasurementContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f68a711')) {
      api.createRecord('2f68a711', component.options)
    } else {
      api.reload('2f68a711', component.options)
    }
    module.hot.accept("./MeasurementContent.vue?vue&type=template&id=2f68a711&", function () {
      api.rerender('2f68a711', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/measurement/MeasurementContent.vue"
export default component.exports